module.exports = __webpack_public_path__ + "static/5-6b663b55f07acfbaa90b5e3f528d1194.jpeg";